"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const galleryItems = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/meal_prep_fresh_ingredients.png",
  alt: "Chef preparing a fresh meal in a bright kitchen",
  title: "Boutique Dining",
  caption: "Fresh, home-cooked meals prepared in our Silver Spring kitchen for our small group of 5 residents."
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/resident_reading_sunroom.png",
  alt: "Senior reading a book by a sunny window",
  title: "Private Sanctuaries",
  caption: "Our boutique Silver Spring home features sun-drenched private rooms for quiet, personalized relaxation."
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/accessible_garden_activity.png",
  alt: "Seniors gardening in raised beds outdoors",
  title: "Personalized Engagement",
  caption: "With only 5 residents, we offer tailored activities and fresh air in our secure Silver Spring garden."
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/caregiver_sharing_tea.png",
  alt: "Caregiver and resident sharing tea and smiling",
  title: "Family-Like Bonds",
  caption: "Our Silver Spring team provides 24/7 support, fostering deep, family-like connections in an intimate setting."
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/living_room_socializing.png",
  alt: "Seniors chatting in a cozy, well-decorated living room",
  title: "Intimate Living",
  caption: "A warm, small-scale Silver Spring home designed for just 5 residents, ensuring meaningful daily interactions."
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586469/img/evening_relaxation_fireplace.png",
  alt: "Cozy evening setting with soft lighting",
  title: "Peaceful Evenings",
  caption: "Relaxing in the safety of a real home environment in Silver Spring, limited to 5 residents for maximum comfort."
}];
export default function ADayInTheLife() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const galleryReveal = useRevealOnScroll({
    threshold: 0.05
  });
  return <section id="a-day-in-the-life" className="py-20 md:py-32 bg-background">
      
    </section>;
}